import React, { useEffect, useState } from 'react';
import {
  Box,
  RadioGroup,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  Typography,
  Button,
  TextField,
  Grid,
  Container
} from '@mui/material';

import { KeyboardArrowLeft } from '@mui/icons-material';
import { PROGRAM, SURGEON, WHYCHOOSE } from '../../../config/picklist';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete } from '@mui/material';
import { useFormik } from 'formik';
import { validateAdditionalInfoForm } from './ValidateAdditionalInfoForm';
import * as caseActions from '../../../actions/caseActions';
// import { useParams } from 'react-router-dom';
import {
  getSurgeonName,
  getWhyChooseText,
  getProgramText,
  getSurgeonValue,
  getWhyChooseValue,
  getProgramValue
} from '../../../config/picklist';
import * as patientActions from '../../../actions/patientActions';
import styles from '../dashboardstyles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import * as Constants from '../../../config/constants';
import * as loginActions from '../../../actions/loginActions';

export default function AdditionalInfo() {
  // let { caseId } = useParams();
  // console.log(caseId);
  // redux
  const st = useSelector((state) => state.rootReducer);
  const dispatch = useDispatch();
  // control navigation target when leave the page
  // const [fromMenu, setFromMenu] = useState(false);
  // flag to see if the page data changed or not
  // const [dataUpdated, setDataUpdated] = useState(false);

  const [showDialog, setShowDialog] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [saveSubmitted, setSaveSubmitted] = useState(false);

  useEffect(() => {
    // callback from other callers outside this component
    if (st.saveAdditonalInfo) {
      submitCaseAdditionalInfo(formik.values);
      dispatch(caseActions.setSaveAdditionalInfo(false));
    }
    //banner success message
    if (saveSubmitted && !st.isUpdateCaseLoading && st.updatebcherror === '') {
      enqueueSnackbar(Constants.UPDATE_CASE_SUCCESS, {
        variant: 'success'
      });
      setSaveSubmitted(false);
    }
  }, [
    st.saveAdditionalInfo,
    st.saveBasicInfo,
    st.isUpdateCaseLoading,
    saveSubmitted,
    st.updatebcherror
  ]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      program: st !== undefined ? getProgramText(st.program) : '',
      preferredSurgeon: st !== undefined ? st.preferredSurgeon : false,
      preferredSurgeonName: st !== undefined ? getSurgeonName(st.preferredSurgeonName) : '',
      preferredCardiologist: st !== undefined ? st.preferredCardiologist : false,
      preferredCardiologistName: st !== undefined ? st.preferredCardiologistName : '',
      inpatient: st !== undefined ? st.inpatient : false,
      whyChoose: st !== undefined ? getWhyChooseText(st.whyChoose) : '',
      hospitalName: st !== undefined ? st.hospitalName : ''
    },
    validationSchema: validateAdditionalInfoForm,
    onSubmit: (values) => {
      // alert('Submit UpdateBCHMDInfo API\n' + JSON.stringify(values, null, 2));
      submitCaseAdditionalInfo(values);
      // console.log(values);
      // handleHome();
      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      setSaveSubmitted(true);
      // reset fromMenu
      // setFromMenu(false);
    }
  });
  let navigate = useNavigate();
  const handleHome = () => {
    if (st.caseId === null || st.caseId === 0 || st.caseId === undefined) {
      navigate('/sop2web/home');
      // reset flag before navigation
      dispatch(caseActions.setDataUpdated(false));
    } else {
      if (st.dataUpdated) {
        setShowDialog(true);
      } else {
        // reset flag before navigation
        dispatch(caseActions.setDataUpdated(false));
        dispatch(caseActions.setViewSummary(true));
      }
    }
    // reset error when navigate out
    if (st.updatecontacterror !== '') dispatch(loginActions.clearError());
  };
  const handleCancel = (event, reason) => {
    if (reason && reason === 'backdropClick') return;
    setShowDialog(false);
    dispatch(caseActions.setViewSummary(true));
    //reset change flag
    dispatch(caseActions.setDataUpdated(false));
    // reset fromMenu
    // setFromMenu(false);
    // reset error when navigate out
    if (st.updatecontacterror !== '') dispatch(loginActions.clearError());
  };
  const submitCaseAdditionalInfo = (values) => {
    dispatch(
      patientActions.persistPatientBCHInfo(
        values.program,
        values.preferredSurgeon,
        values.preferredSurgeonName,
        values.preferredCardiologist,
        values.preferredCardiologistName,
        values.inpatient,
        getWhyChooseValue(values.whyChoose),
        values.hospitalName
      )
    );
    var editCaseBCHInfoRequest = {
      caseId: st.caseId,
      program: getProgramValue(values.program),
      preferredSurgeonName: getSurgeonValue(values.preferredSurgeonName),
      preferredCardiologistName: values.preferredCardiologistName,
      cardiologistName: values.cardiologist,
      typeOfService: values.inpatient === 'true' ? 'Inpatient second opinion' : null,
      whyChosen: getWhyChooseValue(values.whyChoose),
      admittedHospital: values.hospitalName,
      createOrUpdate: 'update',
      email: st.email
    };
    dispatch(caseActions.requestUpdateCaseBCHInfo(editCaseBCHInfoRequest));
  };

  return (
    <Box>
      <Container>
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            flexDirection: 'row',
            adjustItems: 'center',
            border: 0,
            justifyContent: 'space-between'
          }}>
          <Typography variant="h6">
            Case Info for{' '}
            {st !== undefined && st.patient.firstName !== undefined && st.patient.lastName},
            {st !== undefined && st.patient.lastName !== undefined && st.patient.firstName}
            (MRN: {st !== undefined && st.patient.mrn !== undefined ? st.patient.mrn : 'N/A'})
          </Typography>
        </Box>
        <Typography style={styles.titleText}>Additional Requests Information</Typography>

        <Grid container spacing={2}>
          <Grid
            container
            item
            xs={12}
            md={6}
            lg={6}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: 0,
                mt: 6,
                width: 400
              }}>
              <Autocomplete
                id="program"
                sx={{ width: 400 }}
                options={PROGRAM}
                autoHighlight
                getOptionLabel={(option) => {
                  //console.log(option);
                  return option.text !== undefined
                    ? option.text
                    : option !== undefined
                    ? option
                    : '';
                }}
                renderOption={(props, option) => (
                  <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                    {option.text}
                  </Box>
                )}
                renderInput={(params) => (
                  <Box>
                    <TextField
                      {...params}
                      label="Requested clinical program"
                      // size="small"
                      // variant="standard"
                      margin="dense"
                      fullWidth
                      name="program"
                      inputProps={{
                        ...params.inputProps,
                        style: { fontSize: 16 }
                      }}
                      InputLabelProps={{
                        style: { fontSize: 14 }
                      }}
                    />
                  </Box>
                )}
                value={formik.values.program}
                isOptionEqualToValue={(option, value) => option.text === value}
                onChange={(e, value) => {
                  console.log(value);
                  formik.setFieldValue('program', value !== null ? value.text : '');
                  dispatch(caseActions.setDataUpdated(true));
                }}
              />
              <Box
                sx={{
                  justifyContent: 'flex-start',
                  border: 0,
                  mt: 2,
                  width: 400
                }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Do you have a preferred surgeon at BCH?
                </Typography>
                <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                  <FormControl>
                    <FormLabel id="preferredSurgeon-group"></FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="preferredSurgeon"
                      name="preferredSurgeon"
                      value={formik.values.preferredSurgeon}
                      onChange={(e) => {
                        formik.handleChange(e);
                        dispatch(caseActions.setDataUpdated(true));
                      }}>
                      <FormControlLabel
                        value="true"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            Yes
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            No
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
                {(formik.values.preferredSurgeon === true ||
                  formik.values.preferredSurgeon === 'true') && (
                  <Box>
                    <Typography
                      style={{
                        color: '#021D4E',
                        fontWeight: '500',
                        fontSize: 16,
                        textAlign: 'left'
                      }}>
                      Preferred surgeon (optional)
                    </Typography>
                    <Autocomplete
                      id="preferredSurgeonName"
                      sx={{ width: 400 }}
                      options={SURGEON}
                      autoHighlight
                      getOptionLabel={(option) => {
                        //console.log(option);
                        return option.text !== undefined
                          ? option.text
                          : option !== undefined
                          ? option
                          : '';
                      }}
                      renderOption={(props, option) => (
                        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                          {option.text}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <Box>
                          <TextField
                            {...params}
                            label="Preferred surgeon"
                            // size="small"
                            // variant="standard"
                            margin="dense"
                            fullWidth
                            name="preferredSurgeonName"
                            inputProps={{
                              ...params.inputProps,
                              style: { fontSize: 16 }
                            }}
                            InputLabelProps={{
                              style: { fontSize: 14 }
                            }}
                          />
                        </Box>
                      )}
                      value={formik.values.preferredSurgeonName}
                      isOptionEqualToValue={(option, value) => option.text === value}
                      onChange={(e, value) => {
                        console.log(value);
                        formik.setFieldValue(
                          'preferredSurgeonName',
                          value !== null ? value.text : ''
                        );
                        dispatch(caseActions.setDataUpdated(true));
                      }}
                    />
                  </Box>
                )}
                <Box sx={{ mt: 2 }}>
                  <Typography
                    style={{
                      color: '#021D4E',
                      fontWeight: '500',
                      fontSize: 16,
                      textAlign: 'left'
                    }}>
                    Do you have a preferred cardiologist at BCH?
                  </Typography>
                </Box>
                <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                  <FormControl>
                    <FormLabel id="preferredCardiologist-group"></FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="preferredCardiologist"
                      name="preferredCardiologist"
                      value={formik.values.preferredCardiologist}
                      onChange={(e) => {
                        formik.handleChange(e);
                        dispatch(caseActions.setDataUpdated(true));
                      }}>
                      <FormControlLabel
                        value="true"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            Yes
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            No
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
                {(formik.values.preferredCardiologist === true ||
                  formik.values.preferredCardiologist === 'true') && (
                  <Box>
                    <Typography
                      style={{
                        color: '#021D4E',
                        fontWeight: '500',
                        fontSize: 16,
                        textAlign: 'left'
                      }}>
                      Preferred cardiologist (optional)
                    </Typography>
                    <TextField
                      size="small"
                      variant="standard"
                      margin="dense"
                      fullWidth
                      id="preferredCardiologistName"
                      name="preferredCardiologistName"
                      autoComplete="preferredCardiologistName"
                      inputProps={{ style: { fontSize: 16 } }}
                      InputLabelProps={{ style: { fontSize: 14 } }}
                      autoFocus
                      value={formik.values.preferredCardiologistName}
                      onChange={(e) => {
                        formik.handleChange(e);
                        dispatch(caseActions.setDataUpdated(true));
                      }}
                      error={
                        formik.touched.preferredCardiologistName &&
                        Boolean(formik.errors.preferredCardiologistName)
                      }
                      helperText={
                        formik.touched.preferredCardiologistName &&
                        formik.errors.preferredCardiologistName
                      }
                    />
                  </Box>
                )}
              </Box>
            </Box>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={6}
            lg={6}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: 0,
                mt: 0,
                width: 400
              }}>
              <Box
                sx={{
                  justifyContent: 'flex-start',
                  border: 0,
                  mt: 2,
                  width: 400
                }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Is the patient currently an inpatient or hospitalized at another hospital?
                </Typography>
                <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                  <FormControl>
                    <FormLabel id="inpatient-group"></FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="inpatient"
                      name="inpatient"
                      value={formik.values.inpatient}
                      onChange={(e) => {
                        formik.handleChange(e);
                        dispatch(caseActions.setDataUpdated(true));
                      }}>
                      <FormControlLabel
                        value="true"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            Yes
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            No
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
                {(formik.values.inpatient === true || formik.values.inpatient === 'true') && (
                  <Box>
                    <Typography
                      style={{
                        color: '#021D4E',
                        fontWeight: '500',
                        fontSize: 16,
                        textAlign: 'left'
                      }}>
                      What is name of hospital you current admitted to?
                    </Typography>
                    <TextField
                      size="small"
                      variant="standard"
                      margin="dense"
                      fullWidth
                      id="hospitalName"
                      // label="Name of hospital current admitted to"
                      name="hospitalName"
                      autoComplete="hospitalName"
                      inputProps={{ style: { fontSize: 16 } }}
                      InputLabelProps={{ style: { fontSize: 14 } }}
                      autoFocus
                      value={formik.values.hospitalName}
                      onChange={(e) => {
                        formik.handleChange(e);
                        dispatch(caseActions.setDataUpdated(true));
                      }}
                      error={formik.touched.hospitalName && Boolean(formik.errors.hospitalName)}
                      helperText={formik.touched.hospitalName && formik.errors.hospitalName}
                    />
                  </Box>
                )}
                <Box sx={{ mt: 5 }}>
                  <Typography
                    style={{
                      color: '#021D4E',
                      fontWeight: '500',
                      fontSize: 16,
                      textAlign: 'left'
                    }}>
                    Why did you choose Benderson Family Heart Center at BCH?
                  </Typography>
                </Box>
                <Autocomplete
                  id="whyChoose"
                  sx={{ width: 400 }}
                  options={WHYCHOOSE}
                  autoHighlight
                  getOptionLabel={(option) => {
                    //console.log(option);
                    return option.text !== undefined
                      ? option.text
                      : option !== undefined
                      ? option
                      : '';
                  }}
                  renderOption={(props, option) => (
                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                      {option.text}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <Box>
                      <TextField
                        {...params}
                        label="Reason of choose"
                        // size="small"
                        // variant="standard"
                        margin="dense"
                        fullWidth
                        name="whyChoose"
                        inputProps={{
                          ...params.inputProps,
                          style: { fontSize: 16 }
                        }}
                        InputLabelProps={{
                          style: { fontSize: 14 }
                        }}
                      />
                    </Box>
                  )}
                  value={formik.values.whyChoose}
                  isOptionEqualToValue={(option, value) => option.text === value}
                  onChange={(e, value) => {
                    console.log(value);
                    formik.setFieldValue('whyChoose', value !== null ? value.text : '');
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                />
              </Box>
            </Box>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={12}
            lg={12}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box>
              <Typography style={styles.errorText}>{st.updatebcherror}</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                mt: 2,
                border: 0,
                width: 600
              }}>
              <Dialog
                open={showDialog}
                onClose={handleCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Save data?'}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    You are about to leave the form and the form contain unsaved data. Do you want
                    to save?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCancel}>No</Button>
                  <Button
                    onClick={() => {
                      // reset flag
                      dispatch(caseActions.setDataUpdated(false));
                      // reset fromMenu
                      // setFromMenu (false);
                      setShowDialog(false);
                      submitCaseAdditionalInfo(formik.values);
                      dispatch(caseActions.setViewSummary(true));
                    }}
                    autoFocus>
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>
              <Button size="large" variant="contained" sx={{ mb: 5 }} onClick={handleHome}>
                <KeyboardArrowLeft />
                Home
              </Button>
              <Button size="large" variant="contained" onClick={formik.handleSubmit} sx={{ mb: 5 }}>
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
